// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"70dada90","455":"6e9ea374","977":"fc25c195"}[chunkId] + ".chunk.js";
};